import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=7f231e0e&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=7f231e0e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f231e0e",
  null
  
)

/* custom blocks */
import block0 from "./ForgotPassword.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f231e0e')) {
      api.createRecord('7f231e0e', component.options)
    } else {
      api.reload('7f231e0e', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=7f231e0e&scoped=true&", function () {
      api.rerender('7f231e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ForgotPassword.vue"
export default component.exports